import { Button } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import NotRejectedRequests from "./NotRejectedRequests";
import RejectedRequests from "./RejectedRequests";
import CloseIcon from "@mui/icons-material/Close";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";

function AssignmentForOtherDept() {
  let [AssCourses, setAssCourses] = useState([]);
  let [RejectedCoursesData, setRejectedCoursesData] = useState([]);
  let [notRejectedCoursesData, setnotRejectedCoursesData] = useState([]);

  let [rejectedAssCourse, setrejectedAssCourse] = useState([]);
  let [notrejectedAssCourse, setnotrejectedAssCourse] = useState([]);
  let [seeRejectedeList, setseeRejectedList] = useState(false);
  let [isMounted, setIsMounted] = useState(true);

  let { error, setError } = useContext(CourseAssignmentContext);

  let api = useAxiosPrivate();

  let getAssignmentCourses = async (signal) => {
    try {
      let resp = await api.get(
        "courseallocation/allcurrentsemesterRequestedToCourses",
        {
          signal,
        }
      );

      isMounted == true && setAssCourses(resp.data);
    } catch (err) {
      setError(err.response.data.msg);
    }
  };

  function diffRejectedFromNotRejected() {
    let rejectedpile = [];
    let notRejectedPile = [];
    AssCourses.forEach((course) => {
      if (course.declined === true) {
        rejectedpile.push(course);
      } else {
        notRejectedPile.push(course);
      }
    });

    setrejectedAssCourse(rejectedpile);
    setnotrejectedAssCourse(notRejectedPile);
  }
  function alignNotRejectedReqCourses() {
    let arr = [];

    notrejectedAssCourse.forEach((course) => {
      let LEH = course.lab + course.lecture + course.advisory + course.tutorial;
      let arrfordata = [
        course.course_name,
        course.course_code,
        course.credit_hr,
        LEH,
        course.Office.name,
        {
          reject: "Reject",
          courseCode: course.course_code,
          requester: course.Curriculums[0].owner,
          requestedTo: course.owner,
          batch: course.batch,
        },
        course.year, //for filter of batch on front end
        course.admission_type,
        course.program_type,
      ];

      arr.push(arrfordata);
    });

    setnotRejectedCoursesData(arr);
  }

  function alignRejectedReqCourses() {
    let arr = [];

    rejectedAssCourse.forEach((course) => {
      let LEH = course.lab + course.lecture + course.advisory + course.tutorial;
      let arrfordata = [
        course.course_name,
        course.course_code,
        course.credit_hr,
        LEH,
        course.Office.name,
        {
          reject: "Remove From Reject List",
          courseCode: course.course_code,
          requester: course.department,
          requestedTo: course.owner,
          batch: course.batch,
        },
      ];

      arr.push(arrfordata);
    });

    setRejectedCoursesData(arr);
  }

  // eslint-disable-next-line

  useEffect(() => {
    setIsMounted(true);
    const controller = new AbortController();
    getAssignmentCourses(controller.signal);

    setseeRejectedList(false);

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);
  useEffect(() => {
    diffRejectedFromNotRejected();
  }, [AssCourses]);
  useEffect(() => {
    alignNotRejectedReqCourses();
  }, [notrejectedAssCourse]);
  useEffect(() => {
    alignRejectedReqCourses();
  }, [rejectedAssCourse]);

  return (
    <React.Fragment>
      <div
        className="wholeContainer"
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          height: "650px",
          overflowY: "scroll",
        }}
      >
        <div
          className="courseDivContainer"
          style={{

            width: "100%",
            height: "100%",
            overflowY: "scroll",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginBottom: "20px",
              paddingRight: "20px",
            }}
          >
            {seeRejectedeList === false && (
              <Button
                variant="contained"
                onClick={() => setseeRejectedList(true)}
              >
                Rejected List
              </Button>
            )}
            {seeRejectedeList === true && (
              <CloseIcon
                style={{ cursor: "pointer" }}
                onClick={() => setseeRejectedList(false)}
              />
            )}
          </div>
          {seeRejectedeList === false && (
            <NotRejectedRequests
              getAssignmentCourses={getAssignmentCourses}
              notRejectedCoursesData={notRejectedCoursesData}
              AssCourses={AssCourses}
              setAssCourses={setAssCourses}
            />
          )}
          {seeRejectedeList === true && (
            <RejectedRequests
              getAssignmentCourses={getAssignmentCourses}
              RejectedCoursesData={RejectedCoursesData}
              setAssCourses={setAssCourses}
              AssCourses={AssCourses}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default AssignmentForOtherDept;
